import "bootstrap/dist/css/bootstrap.min.css";
import { Image } from "react-bootstrap";
import MessageIcon from "../../../assests/images/search-page-images/message-heart.svg";
import LatestNewsForm from "../latestNewsForm";
import {
    NonProfitMessage,
    MessageImg,
    NonProfitMessText,
    NonProfitMessageTitle,
    GetOurLatestNewsWrap,
} from "./subscribeGridStyle";
import { MESSAGE } from "../../../utils/message";


const SubscribeGrid = () => {

    return (<>

        <GetOurLatestNewsWrap className="get-our-latest-news-wrap">
            <LatestNewsForm />
        </GetOurLatestNewsWrap>


        <NonProfitMessage className="non-profit-message">
            <NonProfitMessageTitle>{MESSAGE.areYouNonprofit}</NonProfitMessageTitle>
            <MessageImg>
                <Image src={MessageIcon} alt="Message Box" />
                <NonProfitMessText>
                    {MESSAGE.areYouNonprofitDescription}
                </NonProfitMessText>
            </MessageImg>
            <button
                type="button"
                onClick={() => window.open(`https://new.greatnonprofits.org/pages/`, '_blank')}
            >
                {MESSAGE.learnMoreBtn}
            </button>

        </NonProfitMessage>

    </>)
};
export default SubscribeGrid; 
